import React from 'react';
import { TrendingUp, TrendingDown, Target, Award } from 'lucide-react';
import './shared-analytics.css';

const AdherenceAnalytics = () => {
  return (
    <div className="adherence-analytics">
      <div className="analytics-summary">
        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0fdf4', color: '#16a34a' }}>
            <Target size={24} />
          </div>
          <div className="card-content">
            <h3>Overall Adherence</h3>
            <div className="card-value">58.9%</div>
            <div className="card-change positive">+3.2% this week</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
            <Award size={24} />
          </div>
          <div className="card-content">
            <h3>High Performers</h3>
            <div className="card-value">3</div>
            <div className="card-change positive">75%+ adherence</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#fef2f2', color: '#dc2626' }}>
            <TrendingDown size={24} />
          </div>
          <div className="card-content">
            <h3>At Risk</h3>
            <div className="card-value">2</div>
            <div className="card-change negative">&lt;50% adherence</div>
          </div>
        </div>

        <div className="summary-card">
          <div className="card-icon" style={{ backgroundColor: '#f0f9ff', color: '#0891b2' }}>
            <TrendingUp size={24} />
          </div>
          <div className="card-content">
            <h3>Improving</h3>
            <div className="card-value">4</div>
            <div className="card-change positive">Positive trend</div>
          </div>
        </div>
      </div>

      <div className="content-placeholder">
        <h3>Comprehensive Adherence Analytics</h3>
        <p>Detailed medication adherence tracking, trends, and intervention recommendations.</p>
        <ul>
          <li>Individual patient adherence patterns</li>
          <li>Medication-specific compliance rates</li>
          <li>Time-based adherence trends</li>
          <li>Intervention effectiveness tracking</li>
        </ul>
      </div>
    </div>
  );
};

export default AdherenceAnalytics;
